import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ProductService } from 'src/app/product.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  public products = {
    'bocciaball-table': {
      name: 'Boccia ballenhouder',
      image: 'https://cdn.twikit.com/projects/assist3d/products/bocciaballtable-9e43230f-6b14-40a7-b1dc-a75eaa118ed0/previews/2020-03-18T20:08:18.376Z/bocciaballtable-9e43230f-6b14-40a7-b1dc-a75eaa118ed0.png'
    },
    'plug-aid': {
      name: 'Stekkerhulp',
      image: 'https://cdn.twikit.com/projects/assist3d/products/stekkerhulp-released-85812e83-63e0-4541-b5f2-17ce77051066/previews/2020-03-18T20:27:08.274Z/stekkerhulp-released-85812e83-63e0-4541-b5f2-17ce77051066.png'
    }
  };

  public productKeys = Object.keys(this.products);

  constructor(private productService: ProductService) { }

  ngOnInit() {
    console.log("ng on init");
    this.productService.selectProduct("Kies een product om te personaliseren");
  }
}
